



























































import api from '@/api'
import { Button } from '@alpha/ink'
import { Vue, Component, Prop } from 'vue-property-decorator'
import analytics from '@/analytics'

@Component({
  components: {
    Button
  }
})
export default class CTADisplay extends Vue {
  @Prop() report!:any
  @Prop() anchor!:any

  header:string = 'THESE INSIGHTS WERE GENERATED USING FEEDBACK LOOP'
  body:string = 'Learn more about making data-driven decisions<br/>about users, products, and new markets.'
  footerImg:string = 'https://alphahq.com/wp-content/themes/alpha/images/product/screens/intuitive-interface.png'
  message:any = {
    type: false,
    message: false
  }

  loading: boolean = false

  processing:boolean = false
  btnText:string = this.anchor ? 'Learn More' : 'Start Testing'
  email:string = ''
  showBubble:boolean = false

  toggleBubble () {
    var that = this
    this.showBubble = !this.showBubble
    if (this.showBubble) {
      var report = this.report
      // These source tapname/tapid from elsewhere, so they must be provided here.
      analytics.track('Interest in Alpha from Shared Report', {
        title: report.title,
        sourceId: report.config ? report.config.id : report.client.viewId,
        tapName: report.client.name,
        tapId: report.client.id,
        module: that.anchor ? 'anchor' : 'display_box',
        action: 'open'
      })
    }
  }

  validateEmail (email:string):boolean {
    var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailPattern.test(email)
  }

  submit (receiver:any) {
    var that = this
    var report = this.report
    var originalBtnText = this.btnText
    // this.addMessage('clear')
    this.btnText = ' Processing...'
    var errors = false
    if (!this.validateEmail(this.email)) {
      errors = true
      this.message.type = 'error'
      this.message.text = 'Please enter a valid email address.'
    }

    if (errors) {
      setTimeout(function () {
        that.btnText = originalBtnText
        receiver.finish()
      }, 120)
    } else {
      this.loading = true
      const data:any = JSON.stringify({
        email: this.email,
        sourceType: 'Shared Report',
        sourceId: report.config ? report.config.id : report.client.viewId
      })
      api.interestSharedReport(data)
        .then(function (res) {
          that.btnText = originalBtnText
          that.message.type = 'success'
          that.message.text = "We'll be in touch shortly."
          that.$emit('emailSent')
          // These source tapname/tapid from elsewhere, so they must be provided here.
          analytics.track('Interest in Alpha from Shared Report', {
            title: report.title,
            sourceId: report.config ? report.config.id : report.client.viewId,
            tapName: report.client.name,
            tapId: report.client.id,
            module: that.anchor ? 'anchor' : 'display_box',
            action: 'interest_expressed'
          })
        })
        .catch(function (err:any) {
          that.btnText = originalBtnText
          that.message.type = 'error'
          that.message.text = 'Something went wrong -- please try again later.'
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
